import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import ArgonDashboard from "./argon-dashboard";
import axios from 'axios';


const defaultApiBaseUrl =
    process.env.NODE_ENV === 'production'
        ? 'https://backend-contract2.artimetrik.com/api'
        : 'http://localhost:8080/api';

const apiClient = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL || defaultApiBaseUrl,
    headers: {
        'Content-Type': 'application/json'
    }
});


apiClient.interceptors.request.use(config => {
    const token = localStorage.getItem('jwtToken');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export default apiClient;

const appInstance = createApp(App);
appInstance.use(store);
appInstance.use(router);
appInstance.use(ArgonDashboard);
appInstance.mount("#app");
